import api from '@pray/shared/utils/api';

export const deleteComment = async ({ artistId, commentId } = {}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!commentId) throw Error('Comment ID is required');

  const url = `/web/studio/artists/${artistId}/comments/${commentId}`;
  const response = await api.executeDeleteRequest(url);
  return response.data.data;
};
